export default __webpack_public_path__ + "static/media/brand_banner.ad467e12.jpg";